module.exports = __webpack_public_path__ + "img/antes_despues_256.c1df0c53.png";